import { createRootRoute, createRoute, createRouter } from '@tanstack/react-router'
import { AccountPage, NotFound, Root } from './App'
import { Devices } from '@/pages/Devices'
import { Regions } from '@/pages/Regions'
import { Shares } from '@/pages/Shares'

// Three views (D-052), and Regions (ADR-0029), linked from Account and from
// purlview.com/regions/ with ?region=; every other address is the not-found view, since the
// Worker answers every path with the app.
const rootRoute = createRootRoute({ component: Root, notFoundComponent: NotFound })
const sharesRoute = createRoute({ getParentRoute: () => rootRoute, path: '/', component: Shares })
const devicesRoute = createRoute({ getParentRoute: () => rootRoute, path: '/devices', component: Devices })
const accountRoute = createRoute({ getParentRoute: () => rootRoute, path: '/account', component: AccountPage })
const regionsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/regions',
  component: Regions,
  validateSearch: (search: Record<string, unknown>): { region?: string } =>
    typeof search.region === 'string' && /^[a-z]+(-[a-z]+)*$/.test(search.region) ? { region: search.region } : {},
})

export const router = createRouter({
  routeTree: rootRoute.addChildren([sharesRoute, devicesRoute, accountRoute, regionsRoute]),
  defaultPreload: false,
  scrollRestoration: true,
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}
